import { BehaviorSubject } from "rxjs";

const initialValue = window?.sessionStorage.getItem("datagrid");

const subject = new BehaviorSubject(
  initialValue ? JSON.parse(initialValue) : {},
);

const store = {
  /**
   * Gets the current value of the stream
   */
  get: (key) => {
    if (!key) return;

    const current = subject.getValue();
    return current?.[key];
  },
  /**
   * Initializes the stream with default values
   */
  init:
    (key) =>
    (value = {}) => {
      const current = subject.getValue();
      subject.next({
        ...current,
        [key]: value,
      });
    },
  /**
   * Write data to the stream
   */
  set: (key) => (value) => {
    console.debug("Setting datagrid stream for %s: %o", key, value);
    const current = subject.getValue();
    subject.next({ ...current, [key]: { ...current[key], ...value } });
  },
  /**
   * Subscribe to the stream
   *
   * @returns {Function} A function to unsubscribe from the stream
   */
  subscribe: (setState) => {
    return subject.subscribe(setState);
  },
};

export { store };
